import { Button } from "react-bootstrap";
import { ArrowUpIcon } from "../../icons/ArrowUpIcon";

const CardBackToTopButton = ({
    onClick= () => {}, 
    isVisible = false,
    position = {right: 0}
}) => {

    if(!isVisible){
        return null
    }

    return(
        <Button 
            onClick={onClick} 
            className="rounded-circle d-flex align-items-center btn-card-back-to-top box-shadow-sm" 
            variant='cyan'
            style={{...position, height: 35, width: 35}}
        >
            <ArrowUpIcon fill='white' height={20} width={'12.5'}/>
        </Button>
    )
}

export default CardBackToTopButton